export const helpers = {
	humanize: {
		paymentMethod: {
			anticipated: "Antecipado",
			bleedings: "Sangria",
			deliveryOnline: "Delivery Online",
			ame: "Ame",
			uber: "Uber",
			ifood: "Ifood",
			app: "Aplicativo",
			cash: "Dinheiro",
			automaticDebit: "Débito Automático",
			boleto: "Boleto",
			bankTransfer: "Transferência bancária",
			promissory: "Nota promissória",
			check: "Cheque",
			creditCard: "Cartão de crédito",
			zigPosCredit: "Zig pós crédito",
			zigCredit: "Zig crédito",
			debitCard: "Cartão de débito",
			zigPosDebit: "Zig pós débito",
			zigDebit: "Zig débito",
			voucher: "Voucher",
			dashboard: "Dashboard",
			postEvent: "Após o evento",
			rappi: "Rappi",
			consumptionFromBar: "Consumação antecipada",
			pix: "Pix",
			bonus: "Bonus",
			other: "Outro",
			zigPosCreditInInstallments: "Crédito parcelado",
			integratedFoodVoucher: "Vale-refeição",
		},
	},
	string: {
		grams: "Gramas",
		kilogram: "Kilogramas",
		liter: "Litros",
		milliliter: "Mililitros",
		unit: "Unidades",
		lowercase: {
			grams: "gramas",
			kilogram: "kilogramas",
			liter: "litros",
			milliliter: "mililitros",
			unit: "unidades",
		},
	},
};
